// Module Import
//---------------------------------
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import { useToast } from '../../../context/ToastContext'
import NotifyForm from '../Forms/NotifyForm'
import TypographyAtom from '../../atoms/typography/typography'
import validateCaptchaToken from '../../../utils/captcha/validateCaptchaToken'
import useFormValidation from '../../../hooks/useFormValidation'
import { notifySchema } from '../../../utils/form/validationSchema'
import { brandOrange } from '../../../assets/consts/color'

// Component Import
//---------------------------------
const Wrapper = styled.div`
  //max-width: 80%;

  & > h4 {
    color: ${brandOrange};
    margin-bottom: 30px;
  }
`

// Styled Component Declarations
//---------------------------------

const defaultValues = {
  email: '',
  checkbox: false,
}

// Component Export
//---------------------------------
export default function NotifyProduct({ selectedVariant }) {
  const [formValues, setFormValues] = useState(defaultValues)
  const [loading, setLoading] = useState(false)
  const [isSent, setIsSent] = useState(false)
  const { showToast } = useToast()
  const { validateValues, validateFieldOnChange, errors } = useFormValidation({
    schema: notifySchema,
  })

  const onSubmit = useCallback(
    async (captchaToken, captchaRef) => {
      setLoading(true)

      const validatedData = await validateValues(formValues)

      if (!validatedData) {
        showToast('Validation error', '')
        setLoading(false)
        return
      }

      const isCaptchaValid = await validateCaptchaToken(captchaToken, showToast, setLoading)

      if (!isCaptchaValid) return

      const variant = selectedVariant?.shopifyId?.replace('gid://shopify/ProductVariant/', '')

      let error = false

      const data = {
        data: {
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                attributes: {
                  email: validatedData.email,
                },
                type: 'profile',
              },
            },
          },
          relationships: {
            variant: {
              data: {
                id: `$shopify:::$default:::${variant}`,
                type: 'catalog-variant',
              },
            },
          },
          type: 'back-in-stock-subscription',
        },
      }
      await axios
        .post('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=U7wVZm', data, {
          headers: {
            revision: '2024-02-15',
          },
        })
        .catch((err) => {
          error = true
          showToast('Register notification', 'Failed subscribe to variant')
          if (captchaRef) captchaRef.reset()
          setLoading(false)
        })

      if (validatedData.checkbox) {
        const data = {
          data: {
            attributes: {
              profile: {
                data: {
                  attributes: {
                    email: validatedData.email,
                  },
                  type: 'profile',
                },
              },
            },
            relationships: {
              list: {
                data: {
                  id: 'Yd8y6k',
                  type: 'list',
                },
              },
            },
            type: 'subscription',
          },
        }
        await axios
          .post('https://a.klaviyo.com/client/subscriptions/?company_id=U7wVZm', data, {
            headers: {
              revision: '2024-02-15',
            },
          })
          .catch((err) => {
            error = true
            showToast('Register notification', 'Failed subscribe to variants')
            if (captchaRef) captchaRef.reset()
            setLoading(false)
          })
      }

      setLoading(false)
      setIsSent(!error)
      if (captchaRef) captchaRef.reset()
    },
    [formValues, selectedVariant]
  )

  const onChange = async ({ target: { name, value } }) => {
    setFormValues((prev) => ({ ...prev, [name]: value }))

    await validateFieldOnChange({ name, value })
  }

  return (
    <Wrapper>
      {!isSent ? (
        <NotifyForm
          errors={errors}
          loading={loading}
          formValues={formValues}
          onChange={onChange}
          onSubmit={onSubmit}
        />
      ) : (
        <TypographyAtom
          weight="Light"
          type="H4"
          copy="You're in! We'll let you know when stock arrives."
        />
      )}
    </Wrapper>
  )
}

NotifyProduct.propTypes = {}
